var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documentDetail"},[_c('div',{staticClass:"question"},[_c('h2',[_vm._v(_vm._s(_vm.question))])]),_c('div',{staticClass:"answer help-answer-body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.answer)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }